<template>
  <div>
    <div class="assignee-ui">
      <div
        v-for="assignee in assignees"
        :key="assignee.id"
        class="dropdown-option-assignee"
        :class="['assignee-data', { active: assignee.id === activeAssigneeId }]"
        @click="setActiveAssignee(assignee.id, assignee)"
      >
        <div class="assignee-img assignee-info">
          <thumbnail
            :key="assignee.id"
            :src="assignee.src"
            :variant="'circle'"
            :username="assignee.name"
            class="user-thumbnail"
            size="30px"
          />
        </div>
        <div class="assignee-name">{{ assignee.name }}</div>
        <span
          v-if="assignee.id === activeAssigneeId"
          class="selected-checkmark"
        >✔</span>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from '../../../../components/widgets/Thumbnail.vue';
export default {
  components: {
    Thumbnail,
  },
  props: {
    assignees: {
      type: Array,
      required: true,
    },
    currentassignee: {
      type: [Number, Object], // Accepts both Number or Object
      default: null, // Provide a default value if necessary
    },
  },
  data() {
    return {
      activeAssigneeId: null, // To track the currently active assignee
    };
  },
  mounted() {
    this.activeAssigneeId = this.currentassignee;
  },
  methods: {
    async setActiveAssignee(id, assignee) {
      this.activeAssigneeId = id; // Set the clicked assignee as active
      // const response = await this.$store.dispatch(
      //   'pipelines/selectAssignee',
      //   status_id
      // );
      // console.log('response', response);
      this.onClose(id, assignee);
    },
    onClose(id, assignee) {
      this.$emit('close', {
        id,
        assignee,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.assignee-ui {
  width: 200px;
  max-height: 168px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  overflow: auto;
}
.assignee-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid lightgray;
  height: 56px;
}
.assignee-info {
  display: flex;
  align-items: center;
  padding: 0px 10px;
}
.active {
  background: #1f94ff;
  color: #fff;
}
.assignee-ui::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.assignee-ui {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  margin-top: 10px;
  position: absolute;
  right: -40px;
}
.dropdown-option-assignee:hover {
  color: #f0f0f0;
  background-color: #007bff;
}
.dropdown-option-assignee {
  font-size: 14px;
  color: grey;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #fff5f5;
}
.assignee-name{
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.selected-checkmark {
  color: #22c55e;
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
  flex-shrink: 0;
}
</style>
